import React, { useContext } from 'react'
import he from 'he'
import ProductKeywords from './ProductKeywords.jsx'
import ProductPurchase from './ProductPurchase.jsx'
import {
  makeStyles,
  Dialog,
  Typography,
  Icon,
  IconButton,
  Divider,
  AppBar,
  Toolbar,
  Box
} from '@material-ui/core'

import { UserContext } from '../../../contexts/UserContext'

const ProductDetails = ({
  item,
  detailsIsOpen,
  setDetailsIsOpen,
  cartBtn,
  isOnCart,
  isSale
}) => {
  const { balance, purchaseItem } = useContext(UserContext)

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row wrap',
      alignItems: 'center',
      '& > *': {
        margin: '10px'
      }
    },
    navStyle: {
      background: '#fff',
      margin: 0,
      height: '10vh',
      display: 'flex',
      justifyContent: 'center'
    },
    backCtn: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: 0
    },
    backBtn: {
      color: '#000',
      display: 'flex',
      justifyContent: 'center'
    },
    itemImageCtn: {
      margin: 0,
      width: '100%',
      height: 300,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderBottom: '1px solid #ccc',
      background: '#f1f1f1',
      [theme.breakpoints.up('sm')]: {
        width: '40%',
        height: 400,
        border: 'none',
        background: 'none',
        marginTop: 10
      }
    },
    itemImage: {
      maxWidth: '100%',
      maxHeight: '100%'
    },
    detailsRoot: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      '& > *': {
        margin: 5
      },
      [theme.breakpoints.up('sm')]: {
        maxWidth: '50%',
        minHeight: '90vh'
      }
    },
    subDetails: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 600,
      '& > *': {
        margin: 'auto 5px'
      }
    },
    faveStyle: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& > span': {
        fontSize: '1.1rem'
      }
    },
    priceCtn: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      alignItems: 'center'
    },
    price: {
      fontWeight: 600
    },
    yourBalance: {
      color: theme.palette.grey[700]
    },
    balance: {
      color: theme.palette.success.main
    },
    descriptionCtn: {
      padding: theme.spacing(2)
    },
    description: {
      color: theme.palette.grey[600]
    }
  }))

  const classes = useStyles()

  const {
    imageUrl: image,
    name,
    popularity,
    price,
    brand,
    days_since_published: days,
    description,
    keywords,
    sale_price,
    quantity_available: available
  } = item

  return (
    <Dialog
      classes={{ paper: classes.root }}
      open={detailsIsOpen}
      onClose={() => setDetailsIsOpen}
      fullScreen
    >
      <AppBar position="static" className={classes.navStyle}>
        <Toolbar className={classes.backCtn}>
          <Typography variant="h5" className={classes.yourBalance}>
            Your Balance:{' '}
            <Typography
              variant="h5"
              display="inline"
              className={classes.balance}
            >
              ${balance.toFixed(2)}
            </Typography>
          </Typography>
          <IconButton
            className={classes.backBtn}
            onClick={() => setDetailsIsOpen(false)}
          >
            <Icon>arrow_backward</Icon>
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className={classes.itemImageCtn}>
        <img className={classes.itemImage} src={image} alt={name} />
      </div>
      <div className={classes.detailsRoot}>
        <Typography variant="h4">{he.decode(String(name))}</Typography>
        <Typography className={classes.subDetails} variant="subtitle2">
          Brand:
          <Typography>{brand && he.decode(String(brand))}</Typography>
        </Typography>
        <Typography className={classes.subDetails} variant="subtitle2">
          Popularity:
          <Typography className={classes.faveStyle} variant="subtitle1">
            <Icon color="error">favorite</Icon> {popularity}
          </Typography>
        </Typography>
        <Typography className={classes.subDetails} variant="subtitle2">
          Keywords:
          {keywords && <ProductKeywords keywords={keywords} />}
        </Typography>
        <div className={classes.priceCtn}>
          <Typography className={classes.price} variant="h5">
            {isSale
              ? `$${(+sale_price).toFixed(2)}`
              : `$${(+price).toFixed(2)}`}
          </Typography>
          <Divider flexItem orientation="vertical" />
          <Typography className={classes.yourBalance}>
            {available} available
          </Typography>
          <Divider flexItem orientation="vertical" />
          <Typography className={classes.yourBalance}>
            {days} days ago
          </Typography>
        </div>
        <Box className={classes.descriptionCtn}>
          <Typography className={classes.description}>
            {description && he.decode(String(description))}
          </Typography>
        </Box>
        <ProductPurchase
          item={item}
          cartBtn={cartBtn}
          isOnCart={isOnCart}
          purchaseItem={purchaseItem}
        />
      </div>
    </Dialog>
  )
}

export default ProductDetails
